<main id="reset-password-main-content">
  <div class="page-container">
    <!-- LEFT COLUMN -->
    <div class="column left" *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP'">
      <div class="texts-container">
        <h1 class="main-title-text" [innerHTML]="'RESET_PASSWORD_PAGE.MAIN_TITLE' | translate" #mainTitleText></h1>
        <h2 class="subtitle-text" [innerHTML]="'RESET_PASSWORD_PAGE.SUBTITLE' | translate"></h2>
      </div>
    </div>

    <!-- RIGHT COLUMN -->
    <div class="column right">
      <div class="utils-buttons-wrapper">
        <app-utils-buttons></app-utils-buttons>
      </div>

      <div class="logo">
        <img src="https://kartapobytu.app/img/logo.png" [alt]="'COMMON.ALTS.LOGO' | translate" />
      </div>

      <!-- FORM -->
      <div class="content-column">
        <ng-container *ngIf="currentMode === MODES.SET">
          <div nz-row>
            <div nz-col [nzSpan]="24">
              <div class="form-title">{{ 'RESET_PASSWORD_PAGE.SET_NEW_PASSWORD' | translate }}</div>
            </div>
          </div>
          <form nz-form [formGroup]="setPasswordForm" id="setPasswordForm">
            <!-- PASSWORD -->
            <nz-form-item [class.has-hint]="!setPasswordForm.controls.password.dirty">
              <nz-form-label [nzSpan]="24" nzRequired nzFor="newPassword">
                {{ 'COMMON.LABEL.NEW_PASSWORD' | translate }}
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzSuffix]="suffixTemplate">
                  <input
                    nz-input
                    required
                    id="newPassword"
                    [type]="isPasswordVisible ? 'text' : 'password'"
                    (focus)="scrollToInput($event)"
                    formControlName="password"
                    placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_NEW_PASSWORD' | translate }}"
                    autocomplete="off"
                    [attr.aria-describedby]="
                      setPasswordForm.controls.password.invalid && setPasswordForm.controls.password.touched
                        ? 'passwordError'
                        : null
                    "
                    [attr.aria-invalid]="setPasswordForm.controls.password.invalid ? 'true' : null" />
                </nz-input-group>

                <ng-template #suffixTemplate>
                  <button
                    type="button"
                    class="toggle-password-btn"
                    tabindex="-1"
                    [attr.aria-label]="'RESET_PASSWORD_PAGE.SHOW_HIDE_PASSWORD' | translate"
                    (click)="isPasswordVisible = !isPasswordVisible">
                    <i nz-icon [nzType]="isPasswordVisible ? 'eye-invisible' : 'eye'"></i>
                  </button>
                </ng-template>

                <div class="hint" *ngIf="!setPasswordForm.get('password').dirty">
                  {{ 'RESET_PASSWORD_PAGE.PASSWORD_HINT' | translate }}
                </div>
              </nz-form-control>

              <!-- ERROR -->
              <mat-error
                *ngIf="setPasswordForm.controls.password.invalid && setPasswordForm.controls.password.touched"
                id="passwordError">
                {{ setPasswordForm.controls.password.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </nz-form-item>

            <!-- CONFIRM PASSWORD -->
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired nzFor="newPasswordConfirmation">
                {{ 'COMMON.LABEL.NEW_PASSWORD_CONFIRMATION' | translate }}
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-input-group [nzSuffix]="suffixConfirmTemplate">
                  <input
                    nz-input
                    required
                    id="newPasswordConfirmation"
                    [type]="isPasswordConfirmVisible ? 'text' : 'password'"
                    (focus)="scrollToInput($event)"
                    formControlName="passwordConfirmation"
                    placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_NEW_PASSWORD_CONFIRMATION' | translate }}"
                    autocomplete="off"
                    [attr.aria-describedby]="
                      setPasswordForm.controls.passwordConfirmation.invalid &&
                      setPasswordForm.controls.passwordConfirmation.touched
                        ? 'passwordConfirmationError'
                        : null
                    "
                    [attr.aria-invalid]="setPasswordForm.controls.passwordConfirmation.invalid ? 'true' : null" />
                </nz-input-group>

                <ng-template #suffixConfirmTemplate>
                  <button
                    type="button"
                    class="toggle-password-btn"
                    [attr.aria-label]="'RESET_PASSWORD_PAGE.SHOW_HIDE_PASSWORD' | translate"
                    (click)="isPasswordConfirmVisible = !isPasswordConfirmVisible">
                    <i nz-icon [nzType]="isPasswordConfirmVisible ? 'eye-invisible' : 'eye'"></i>
                  </button>
                </ng-template>
              </nz-form-control>

              <!-- ERROR -->
              <mat-error
                *ngIf="
                  setPasswordForm.controls.passwordConfirmation.invalid &&
                  setPasswordForm.controls.passwordConfirmation.touched
                "
                id="passwordConfirmationError">
                {{ setPasswordForm.controls.passwordConfirmation.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </nz-form-item>

            <!-- SUBMIT BUTTON -->
            <div nz-row>
              <div nz-col [nzSpan]="24">
                <button
                  (click)="setNewPassword()"
                  id="setNewPasswordSubmitButton"
                  class="submit-button"
                  [disabled]="
                    setPasswordForm.pristine || (setPasswordForm.dirty && setPasswordForm.invalid) || (loading$ | async)
                  "
                  mat-raised-button
                  color="primary">
                  {{ 'RESET_PASSWORD_PAGE.SET_PASSWORD' | translate }}
                </button>
              </div>
            </div>
            <div class="loading-container" *ngIf="loading$ | async">
              <mat-spinner [diameter]="35"></mat-spinner>
            </div>

            <div
              class="error-message-container"
              *ngIf="setPasswordForm.get('passwordConfirmation')?.dirty && setPasswordForm.errors?.noMatch">
              <p>{{ 'RESET_PASSWORD_PAGE.PASSWORDS_DO_NOT_MATCH' | translate }}</p>
            </div>
            <div
              *ngIf="errorMessage$ | async as errorMessage"
              [ngSwitch]="errorMessage"
              #errorMessageContainer
              class="error-message-container">
              <div *ngSwitchCase="'COMMON.ERROR.UNAUTHORIZED'">
                <div
                  class="main-error-message"
                  [innerHTML]="'RESET_PASSWORD_PAGE.ERRORS.UNAUTHORIZED' | translate"></div>
                <div class="error-explanations">
                  <ul>
                    <li [innerHTML]="'RESET_PASSWORD_PAGE.CHECK_EMAIL_WITH_LINK' | translate"></li>
                    <li [innerHTML]="'RESET_PASSWORD_PAGE.ACTIVATION_LINK_EXPIRATION' | translate"></li>
                    <li [innerHTML]="'RESET_PASSWORD_PAGE.YOU_CAN_REGENERATE_LINK' | translate"></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="back-to-login-link">
              <a (click)="$event.preventDefault()" [routerLink]="['/login']">
                {{ 'COMMON.REDIRECT.BACK_TO_LOGIN' | translate }}
              </a>
            </div>
          </form>
        </ng-container>
        <ng-container *ngIf="currentMode === MODES.REQUEST">
          <div nz-row>
            <div nz-col [nzSpan]="24">
              <div class="form-title">{{ 'RESET_PASSWORD_PAGE.RESET_PASSWORD' | translate }}</div>
            </div>
          </div>
          <form nz-form [formGroup]="requestResetPasswordForm">
            <!-- EMAIL -->
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired nzFor="passwordResetToEmail"
                >{{ 'COMMON.LABEL.EMAIL' | translate }}
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input
                  nz-input
                  required
                  id="passwordResetToEmail"
                  type="text"
                  (focus)="scrollToInput($event)"
                  formControlName="email"
                  placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_EMAIL' | translate }}"
                  autocomplete="off"
                  [attr.aria-describedby]="
                    requestResetPasswordForm.controls.email.invalid && requestResetPasswordForm.controls.email.touched
                      ? 'emailError'
                      : null
                  "
                  [attr.aria-invalid]="requestResetPasswordForm.controls.email.invalid ? 'true' : null" />
              </nz-form-control>
              <!-- ERROR -->
              <mat-error
                *ngIf="
                  requestResetPasswordForm.controls.email.invalid && requestResetPasswordForm.controls.email.touched
                "
                id="emailError">
                {{ requestResetPasswordForm.controls.email.errors | errorsFormatingAndTranslate }}
              </mat-error>

              <div class="hint mail-hint">
                {{ 'RESET_PASSWORD_PAGE.MAIL_HINT' | translate }}
              </div>
            </nz-form-item>

            <!-- SUBMIT BUTTON -->
            <div nz-row>
              <div nz-col [nzSpan]="24">
                <button
                  (click)="requestPasswordReset()"
                  id="requestPasswordResetSubmitButton"
                  class="submit-button"
                  [disabled]="
                    requestResetPasswordForm.pristine ||
                    (requestResetPasswordForm.dirty && requestResetPasswordForm.invalid) ||
                    (loading$ | async)
                  "
                  mat-raised-button
                  color="primary">
                  {{ 'RESET_PASSWORD_PAGE.RESET_PASSWORD' | translate }}
                </button>
                <div class="error-message-container" *ngIf="errorMessage$ | async as errorMessage">
                  <p>{{ errorMessage | translate }}</p>
                </div>
                <div class="loading-container" *ngIf="loading$ | async">
                  <mat-spinner [diameter]="35"></mat-spinner>
                </div>
                <div class="back-to-login-link">
                  <a (click)="$event.preventDefault()" [routerLink]="['/login']">
                    {{ 'COMMON.REDIRECT.BACK_TO_LOGIN' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </form>
        </ng-container>
        <ng-container *ngIf="currentMode === MODES.REQUEST_SUCCESS">
          <div nz-row>
            <div nz-col [nzSpan]="24">
              <div class="success-message">{{ 'RESET_PASSWORD_PAGE.PASSWORD_RESET_REQUEST_RECEIVED' | translate }}</div>
            </div>
          </div>
          <div nz-row>
            <div nz-col [nzSpan]="24">
              <div class="hint mail-hint">
                {{ 'RESET_PASSWORD_PAGE.YOU_CAN_CLOSE_THIS_PAGE' | translate }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</main>
